import type { ReactNode } from 'react';
import track from 'react-tracking';
import { Modal } from '@simplywallst/ui-core';

interface RawDataModalProps {
  title?: ReactNode;
  onClose: () => void;
  children: ReactNode;
}

const RawDataModal = ({ title, onClose, children }: RawDataModalProps) => {
  return (
    <Modal
      title={title}
      onSecondaryClick={onClose}
      onPrimaryClick={onClose}
      primaryLabel="Close"
    >
      <div>{children}</div>
    </Modal>
  );
};

export default track(({ title }) => ({
  type: 'track',
  chart: title,
  subject: 'RawDataModal',
}))(RawDataModal);
